
/**
 * List of stages a portfolio company passes through during its lifecycle
 */
export enum CompanyStage {
    Forming = 'Forming',
    Active = 'Active',
    WindDown = 'Wind Down',
    Exited = 'Exited'
}

